import presentationDefaultState from './presentation'
import slideActiveDefaultState from './slideActive'
import teamDefaultState from './team'

export default {
  ...presentationDefaultState,
  ...slideActiveDefaultState,
  ...teamDefaultState,
}
